module.exports = __webpack_public_path__ + "static/media/aaronface.716d575b.jpg";